import React from "react";
import {
  Routes,
  Route,
  BrowserRouter,
  Navigate,
  useLocation,
} from "react-router-dom";
import { v4 as uuidv4 } from "uuid";
import { useSelector } from "react-redux";
import Cookies from "js-cookie";
import Layout from "../layout";
import SignInWithValidation from "../pages/signin";
import ForgotPassword from "../pages/forgot_password";
import ForgotPasswordVerify from "../pages/forgotpassword";
import ResetPassword from "../pages/resetpassword";
import Home from "../pages/home";
import ProductCreate from "../pages/products/create";
import ProductDetails from "../pages/products/create/product_details";
import ProductMapping from "../pages/products/mapping";
import ProductPricing from "../pages/products/pricing";
import Clients from "../pages/clients";
import Orders from "../pages/orders";
import ChangeCredentials from "../pages/settings/change_credentials";
import Notification from "../pages/settings/notification";
import UserCreation from "../pages/user_creation";
import OfferGeneral from "../pages/offer/general";
import OfferSpecific from "../pages/offer/specific";
import NotFound from "../pages/404";
import Enquiry from '../pages/enquiry'
const generateParams = () => {
  const aaddeef = uuidv4();
  const ewdser = Date.now();
  return { aaddeef, ewdser };
};

const isTimestampValid = (ewdser) => {
  const currentTime = Date.now();
  const timeDifference = currentTime - ewdser;
  return timeDifference <= 15000;
};

const RootRedirect = () => {
  const { aaddeef, ewdser } = generateParams();
  return <Navigate to={`/signin?aaddeef=${aaddeef}&ewdser=${ewdser}`} />;
};

const Router = () => {
  const isAuthenticated = useSelector(
    (state) => state.authReducer.isAuthenticated
  );
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<RootRedirect />} />
        <Route path="/signin" element={<SignInWithValidation />} />
        <Route path="/forgotpassword" element={<ForgotPassword />} />
        <Route path="/setpassword/:token" element={<ResetPassword />} />
        <Route
          path="/resetpassword/:token"
          element={<ForgotPasswordVerify />}
        />
        <Route
          path="/productcreate"
          element={
            isAuthenticated ? (
              <Layout>
                <ProductCreate />
              </Layout>
            ) : (
              <Navigate to="/" />
            )
          }
        />
        <Route
          path="/enquiry"
          element={
            isAuthenticated ? (
              <Layout>
                <Enquiry />
              </Layout>
            ) : (
              <Navigate to="/" />
            )
          }
        />
        <Route
          path="/productdetails"
          element={
            isAuthenticated ? (
              <Layout>
                <ProductDetails />
              </Layout>
            ) : (
              <Navigate to="/" />
            )
          }
        />
        <Route
          path="/productmapping"
          element={
            isAuthenticated ? (
              <Layout>
                <ProductMapping />
              </Layout>
            ) : (
              <Navigate to="/" />
            )
          }
        />
        <Route
          path="/productpricing"
          element={
            isAuthenticated ? (
              <Layout>
                <ProductPricing />
              </Layout>
            ) : (
              <Navigate to="/" />
            )
          }
        />
        <Route
          path="/clients"
          element={
            isAuthenticated ? (
              <Layout>
                <Clients />
              </Layout>
            ) : (
              <Navigate to="/" />
            )
          }
        />
        <Route
          path="/offer/general"
          element={
            isAuthenticated ? (
              <Layout>
                <OfferGeneral />
              </Layout>
            ) : (
              <Navigate to="/" />
            )
          }
        />
        <Route
          path="/offer/specific"
          element={
            isAuthenticated ? (
              <Layout>
                <OfferSpecific />
              </Layout>
            ) : (
              <Navigate to="/" />
            )
          }
        />
        <Route
          path="/orders"
          element={
            isAuthenticated ? (
              <Layout>
                <Orders />
              </Layout>
            ) : (
              <Navigate to="/" />
            )
          }
        />
        <Route
          path="/home"
          element={
            isAuthenticated ? (
              <Layout>
                <Home />
              </Layout>
            ) : (
              <Navigate to="/" />
            )
          }
        />
        <Route
          path="/changecredentails"
          element={
            isAuthenticated ? (
              <Layout>
                <ChangeCredentials />
              </Layout>
            ) : (
              <Navigate to="/" />
            )
          }
        />
        <Route
          path="/notification"
          element={
            isAuthenticated ? (
              <Layout>
                <Notification />
              </Layout>
            ) : (
              <Navigate to="/" />
            )
          }
        />
        <Route
          path="/users"
          element={
            isAuthenticated ? (
              <Layout>
                <UserCreation />
              </Layout>
            ) : (
              <Navigate to="/" />
            )
          }
        />
        <Route path="/signin" element={<NotFound />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
};

export default Router;
